import React from 'react';
import "./TenureInfo.scss";

const titleCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const tenureType = (type) => {
  switch (type) {
    case 'Shareoffreehold':
    case 'shareOfFreehold': // Feed data
      return 'share of Freehold';
    default:
      return type;
  }
};


const TenureInfo = ({ sellingInfo, extra, lettingInfo, searchType, propertyPrice }) => {
  
  var psr1 = ""
  var psr2 =""
  if(lettingInfo?.deposit?.amount != 0 && lettingInfo && searchType == "lettings") {
    if(lettingInfo?.deposit?.type == "weeks") {
        psr1 = propertyPrice * 12 / 52 * lettingInfo?.deposit?.amount;
    } else if ((lettingInfo?.deposit?.type == "months") || (lettingInfo?.deposit?.type == "month")) {
        psr1 = propertyPrice * lettingInfo?.deposit?.amount;
    }else if (lettingInfo?.deposit?.type == "fixed") {
        psr1 = propertyPrice;
    }
    psr2 = parseInt(psr1);
  }

  return (
    <ul className="tenure-listing">
      {extra?.tenure && searchType === "sales" &&
        <li className="tenure-info">
          <p className="tenure-title">Tenure</p>
          <p className="tenure-value">{tenureType(titleCase(extra?.tenure))}</p>
        </li>
      }
      {lettingInfo?.deposit?.amount != 0 && searchType == "lettings" &&
          <li className="tenure-info">
            <p className="tenure-title">Security Deposit</p>
            <p className="tenure-value"><span>£{psr2.toLocaleString()}</span></p>                    
          </li>
      }
      {extra?.groundRent !== 0 && extra?.groundRent &&
        <li className="tenure-info">
          <p className="tenure-title">Ground Rent</p>
          <div className={`tenure-value ${extra?.groundRentComment ? "wrap-comment" : ""}`}>
            <span>£{extra?.groundRent}</span>
            <span className="sm-small">{extra?.groundRentComment ? ` (${extra?.groundRentComment})` : ""}</span>
          </div>
        </li>
      }
      {extra?.serviceCharge !== 0 && extra?.serviceCharge &&
        <li className="tenure-info">
          <p className="tenure-title">Service Charge</p>
          <div className={`tenure-value ${extra?.serviceChargeComment ? "wrap-comment" : ""}`}>
            <span>£{extra?.serviceCharge}</span>
            <span className="sm-small">{extra?.serviceChargeComment ? ` (${extra?.serviceChargeComment})` : ""}</span>
          </div>
        </li>
      }
      {lettingInfo?.minimumTerm !== 0 && lettingInfo && searchType === "lettings" &&
        <li className="tenure-info">
          <p className="tenure-title">Length of lease</p>
          <p className="tenure-value">{lettingInfo?.minimumTerm}</p>
        </li>
      }
    </ul>
  );
};

export default TenureInfo;